import { render, staticRenderFns } from "./booking-board.vue?vue&type=template&id=0a044292&scoped=true"
import script from "./booking-board.vue?vue&type=script&lang=js"
export * from "./booking-board.vue?vue&type=script&lang=js"
import style0 from "./booking-board.vue?vue&type=style&index=0&id=0a044292&prod&lang=css"
import style1 from "./booking-board.vue?vue&type=style&index=1&id=0a044292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a044292",
  null
  
)

export default component.exports